const headers = [
  {
    label: "",
    field: "removeButton",
    tdClass: "text-center",
  },
  {
    label: "สถานะการใช้งาน",
    field: "isActive",
    tdClass: "text-center",
  },
  {
    label: "ประธานอนุกรรมการ",
    field: "isDirector",
    tdClass: "text-center",
  },
  {
    label: "ชื่อกลุ่มอนุกรรมการ",
    field: "groupName",
    tdClass: "",
  },
  {
    label: "ชื่อ-นามสกุล",
    field: "fullName",
    tdClass: "",
  },
  {
    label: "ตำแหน่งในอนุกรรมการ",
    field: "directorPositionName",
    tdClass: "",
  },
  {
    label: "หน่วยงาน",
    field: "divisionName",
    tdClass: "",
  },
  {
    label: "เบอร์โทร",
    field: "tel",
    tdClass: "",
  },
  {
    label: "เบอร์มือถือ",
    field: "mobile",
    tdClass: "",
  },
  {
    label: "อีเมล",
    field: "email",
    tdClass: "",
  },
];

export default headers;
